export default "__VITE_ASSET__be24aca0__"